import globals from "./globals";
import $ from "cash-dom";

const component = (function () {
    $(document).ready(function () {
        if ($("a, li:has(a), button, input").length) {
            if (globals.debug) console.log("component-tab-focus initialized");

            $("body").on("keyup", "a, li:has(a), button, input", function (_e) {
                if (_e.which == 9) {
                    $(".tab-focus").removeClass("tab-focus");
                    $(_e.target).addClass("tab-focus");
                }
            });
        }
    });
})();

export default component;
